import debounce from "lodash/debounce";
import type { Dispatch, SetStateAction } from "react";
import { useRef } from "react";

/**
 * Custom hook that creates a debounced function for setting search terms
 * @param delay The delay in milliseconds
 * @returns A debounced function that takes a term and a setState function
 */
export const useDebouncedSetSearchTerm = (delay = 450) => {
    return useRef(
        debounce((term: string, setTerm: Dispatch<SetStateAction<string>>) => {
            setTerm(term);
        }, delay),
    ).current;
};
